
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termos-psicologos",
      function () {
        return require("private-next-pages/termos-psicologos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termos-psicologos"])
      });
    }
  